import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';


const RolesTable = ({ accountDetail, handleAddRoles }) => {
  return (
    <div className="accounts-roles-table">
      <div className="table-wrapper">
        <div className="table-head">
          <table>
            <thead>
              <tr className="table-row table-row-head">
                <th className="table-cell table-cell-name">
                  <span className="text-left display-block padding-left-15">Roles</span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">Description</span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">Updated By</span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">Created Date</span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">Updated Date</span>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="table-body">
          <table>
            <tbody>
              {
                accountDetail.roles.map((role, i) => {
                  if (role.name.trim() && role.description.trim()) {
                    return (
                      <tr key={`${accountDetail.accountId}_${i}`} className="table-row table-row-body">
                        <td className="table-cell table-cell-name" >
                          <button onClick={() => handleAddRoles(role)} className="table-cell-button">
                            <span className="col-text">{role.name}</span>
                          </button>
                        </td>
                        <td className="table-cell table-cell-date" >
                          <span className="col-text text-left">{role.description}</span>
                        </td>
                        <td className="table-cell table-cell-date" >
                          <span className="col-text text-left">{role.updatedByUser}</span>
                        </td>
                        <td className="table-cell table-cell-date" >
                          <span className="col-text text-left">{moment(role.creationDate).format('MM DD YYYY hh:mm:ss')}</span>
                        </td>
                        <td className="table-cell table-cell-date" >
                          <span className="col-text text-left">{moment(role.updatedDate).format('MM DD YYYY hh:mm:ss')}</span>
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};


RolesTable.propTypes = {
  accountDetail: PropTypes.instanceOf(Object),
  handleAddRoles: PropTypes.func,
};

export default RolesTable;
